import Cookies from 'js-cookie'

const TOKEN_KEY = 'token'

export const getToken = (): string => {
  return Cookies.get(TOKEN_KEY)
}

export const setToken = (token: string, expiresIn = 7): void => {
  Cookies.set(TOKEN_KEY, token, { expires: expiresIn })
}

export const removeToken = (): void => {
  return Cookies.remove(TOKEN_KEY)
}
